import { z } from 'zod';

import { defineFcm } from '../shared/factory';

export const FCM_CONSTITUENT_PSF_EXPERIMENT = defineFcm('constituent_psf_experiment')
	.asJson(
		z.object({
			enabled: z.boolean().optional(),
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-chameleon',
		scope: 'corgi-front-end',
		context: 'PSF share page (Constituents-in-PSF)',
		description: `Access gate for the Constituents-in-PSF experiment (constituent_psf_experiment), which shows identified local
			constituents new share and goal screens after signing. Defaults to disabled everywhere; enable the US country row to
			roll it out to the US only. The en-US locale row can be used instead if the experiment needs to exclude es-US, since a
			locale row wins over a country row.`,
		supportedGroups: { locales: true, countries: true },
		template: { enabled: true },
	});
